/**
 * Canonical platform-role union. Administrator owns organisation operations,
 * Builder adds specialist creation, and Member adds neither; per-specialist
 * authority is resolved independently from specialist assignments.
 */

export const USER_ROLES = ["admin", "builder", "member"] as const;

export type UserRole = (typeof USER_ROLES)[number];

export function isUserRole(value: unknown): value is UserRole {
  return typeof value === "string" && (USER_ROLES as readonly string[]).includes(value);
}
